import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { catalogConstructionTypeIsUsedInProjectsGql } from '../catalogConstructionTypesQueries';

const requestId = 'catalogConstructionTypeIsUsedInProjects';

export const useConstructionTypeIsUsedInProjects = () => {
    const dispatch = useDispatch();
    const [isCheckingUsage, setIsCheckingUsage] = useState(false);
    const [isUsageCheckError, setIsUsageCheckError] = useState(false);

    const [resetUsageData] = useResetStoreData({ requestId });

    const [, usageStatus, usageError, usageRequest] = useRequest({
        requestId,
        query: catalogConstructionTypeIsUsedInProjectsGql,
        withEffect: false,
    });

    useEffect(() => {
        resetUsageData(undefined);
    }, [resetUsageData]);

    useEffect(() => {
        if (isCheckingUsage && usageStatus === RequestStatus.ERROR) {
            setIsCheckingUsage(false);
            setIsUsageCheckError(true);
        }
    }, [isCheckingUsage, usageStatus]);

    const checkUsage = (code: string, onResult: (isUsed: boolean) => void) => {
        setIsCheckingUsage(true);
        setIsUsageCheckError(false);

        dispatch(
            usageRequest({ code }, ({ payload }) => {
                setIsCheckingUsage(false);
                onResult(Boolean(payload?.catalogConstructionTypeIsUsedInProjects?.result));
            }),
        );
    };

    const handleCloseUsageError = () => {
        setIsUsageCheckError(false);
        resetUsageData(undefined);
    };

    return {
        checkUsage,
        isCheckingUsage,
        isUsageCheckError,
        usageStatus,
        usageError,
        handleCloseUsageError,
    };
};
